import React from "react";
import { Box, Grid } from "@mui/material";
import { useWidth } from "../../../../../libs/hooks";
// import {
//   message,
// } from "antd";
import { CardComponent } from "./card-component";
import { TableComponent } from "./table-component";
import {
  workflowContainerCheckPointCount,
  workflowContainerEmptyCount,
  workflowContainerFullCount,
  workflowTruckCount,
} from "../../../../../libs/apis";

export const AdministratorComponent = ({ options }: { options: any[] }) => {
  const width = useWidth();
  const [valueEmpty, setValueEmpty] = React.useState("Hoy");
  const [valueFull, setValueFull] = React.useState("Hoy");
  const [valueCheck, setValueCheck] = React.useState("Hoy");
  const [valueTruck, setValueTruck] = React.useState("Hoy");
  const [totalEmpty, setTotalEmpty] = React.useState(0);
  const [totalFull, setTotalFull] = React.useState(0);
  const [totalCheck, setTotalCheck] = React.useState(0);
  const [totalTruck, setTotalTruck] = React.useState(0);

  React.useEffect(() => {
    handleGetData();
  }, []);

  const handleGetData = async () => {
    try {
      handleGetEmpty("hoy");
      handleGetFull("hoy");
      handleGetCheckPoint("hoy");
      handleGetTruck("hoy");
    } catch (err: any) {
      console.log(err.toString());
    }
  };
  const handleUpdateEmpty = React.useCallback(
    (val: string) => {
      const fill = options.find((el) => el.value === val);
      setValueEmpty(fill.label);
      handleGetEmpty(fill.value);
    },
    [options]
  );

  const handleUpdateFull = React.useCallback(
    (val: string) => {
      const fill = options.find((el) => el.value === val);
      setValueFull(fill.label);
      handleGetFull(fill.value);
    },
    [options]
  );

  const handleUpdateCheckPoint = React.useCallback(
    (val: string) => {
      const fill = options.find((el) => el.value === val);
      setValueCheck(fill.label);
      handleGetCheckPoint(fill.value);
    },
    [options]
  );

  const handleUpdateTruck = React.useCallback(
    (val: string) => {
      const fill = options.find((el) => el.value === val);
      setValueTruck(fill.label);
      handleGetTruck(fill.value);
    },
    [options]
  );

  const handleGetEmpty = async (value: string) => {
    try {
      const { data: dataEmpty } = await workflowContainerEmptyCount(value);
      if (!dataEmpty) return;
      setTotalEmpty(dataEmpty.total);
    } catch (err: any) {
      console.log(err.toString());
    }
  };

  const handleGetFull = async (value: string) => {
    try {
      const { data: dataFull } = await workflowContainerFullCount(value);
      if (!dataFull) return;
      setTotalFull(dataFull.total);
    } catch (err: any) {
      console.log(err.toString());
    }
  };

  const handleGetCheckPoint = async (value: string) => {
    try {
      const { data: dataCheckPoint } = await workflowContainerCheckPointCount(
        value
      );
      if (!dataCheckPoint) return;
      setTotalCheck(dataCheckPoint.total);
    } catch (err: any) {
      console.log(err.toString());
    }
  };

  const handleGetTruck = async (value: string) => {
    try {
      const { data: dataTruck } = await workflowTruckCount(value);
      if (!dataTruck) return;
      setTotalTruck(dataTruck.total);
    } catch (err: any) {
      console.log(err.toString());
    }
  };


  return (
    <Box
      sx={{
        p: 1,
        height: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        overflowY: "auto",
      }}
    >
      <Grid container spacing={6} justifyContent="center">
        <Grid item xs={6} sm={2.5}>
          <CardComponent
            width={width}
            title="Contenedores Vacíos"
            quantity={totalEmpty}
            handleUpdate={handleUpdateEmpty}
            options={options}
            color="tomato"
            value={valueEmpty}
          />
        </Grid>
        <Grid item xs={6} sm={2.5}>
          <CardComponent
            width={width}
            title="Contenedores Full"
            quantity={totalFull}
            handleUpdate={handleUpdateFull}
            options={options}
            color="orange"
            value={valueFull}
          />
        </Grid>
        <Grid item xs={6} sm={2.5}>
          <CardComponent
            width={width}
            title="CheckPoint"
            quantity={totalCheck}
            handleUpdate={handleUpdateCheckPoint}
            options={options}
            color="green"
            value={valueCheck}
          />
        </Grid>
        <Grid item xs={6} sm={2.5}>
          <CardComponent
            width={width}
            title="Camión"
            quantity={totalTruck}
            handleUpdate={handleUpdateTruck}
            options={options}
            color="blue"
            value={valueTruck}
          />
        </Grid>
        <Grid item xs={12}>
          <TableComponent />
        </Grid>
      </Grid>
    </Box>
  );
};
